import createLucideIcon from '../createLucideIcon';

const ChevronLeft = createLucideIcon('ChevronLeft', [
  ['polyline', { points: '15 18 9 12 15 6', key: 'kvxz59' }],
]);

export default ChevronLeft;
